import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom';

import classes from './../Onboarding.module.scss';
import UpperDiv from './UpperDiv';
import LowerDiv from './LowerDiv';
import register_1 from './../../../assets/onboarding/register_1.svg'
import register_2 from './../../../assets/onboarding/register_2.svg'
import Pagination from './Pagination';

const upperDivStyle = {
  display: "flex",
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  gap: 0
}

const lowerDivStyle = {
  display: "flex",
  flexDirection: 'column',
  gap: '0'
}

const problem_1_style = {
  maxWidth: '90%',
}

const problem_2_style = {
  maxWidth: '25%',
  marginLeft: -20
}

const Page7 = () => {
  const data = JSON.parse(localStorage.getItem('data'))
  const navigate = useNavigate();
  const [isPhoto, setIsPhoto] = useState(false);

 

  useEffect(() => {
    if (data) {
      if (data.photo === null || data.photo.toString().trim().length < 100 ) {
        setIsPhoto(true);
        return;
      } else {
        setIsPhoto(false);
      }
    }
  }, [])

  const handleClick = (event) =>{
    event.preventDefault()
    if(isPhoto){
      navigate('/dashboard/changeface')
    }else{
      navigate('/dashboard/home');
    }
  }

return (
  <>
    <UpperDiv style={upperDivStyle}>
      <img src={register_1} alt="" style={problem_1_style} />

    </UpperDiv>
    <LowerDiv style={lowerDivStyle}>
      <div className={classes.Page2Div}>
        <img src={register_2} alt="" style={problem_2_style} />
        <h3 className={classes.Page2H3}>
          While Registering Your Photo
        </h3>
        <p className={classes.NameH3}>
          Make sure to keep your phone at least one foot away from your face while taking the photo,
          and ensure that there is no one in the background.
        </p>
      </div>
      <div className={classes.Page2Pagination}>
        <button onClick={handleClick}>
          {isPhoto?"REGISTER FACE" : "GO TO HOME"}
        </button>
        <Pagination numberOfDots={7} activePage={7} />
      </div>
    </LowerDiv>
  </>
)
}

export default Page7